import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/support-portal/frontend-webui/components/layout-provider.tsx");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/support-portal/frontend-webui/styles/global.css");
